import api from "@/services/api";

export const state = {
  cantons: [],
  canton: {},
};

export const mutations = {
  INIT_CANTONS(state, payload) {
    state.cantons = payload;
  },
  INIT_CANTON(state, payload) {
    state.canton = payload;
  },
};

export const actions = {
  getCantons({ commit }, payload) {
    return api.getCantons(payload).then((response) => {
      commit("INIT_CANTONS", response.data.data);

      if (!payload.retrieveAll) commit("pager/INIT_PAGER", response.data.pagedResult, { root: true });
    });
  },
  getCantonbyId({ commit }, payload) {
    return api.getCantonById(payload).then((response) => {
      commit("INIT_CANTON", response.data.data);
    });
  },
};

export const getters = {
  getCantons: (state) => state.cantons,
  getCanton: (state) => state.canton,
};
